const useLogger = () => {
  const isLocalhost = import.meta.env.VITE_API_URL?.includes('localhost')

  const log = (...args: unknown[]) => {
    if (isLocalhost) {
      console.log(...args)
    }
  }

  const warn = (...args: unknown[]) => {
    if (isLocalhost) {
      console.warn(...args)
    }
  }

  const error = (...args: unknown[]) => {
    if (isLocalhost) {
      console.error(...args)
    }
  }

  return {
    log,
    warn,
    error
  }
}

export default useLogger 